import { render, staticRenderFns } from "./sidebar-guest.vue?vue&type=template&id=210c622a&scoped=true"
import script from "./sidebar-guest.vue?vue&type=script&lang=js"
export * from "./sidebar-guest.vue?vue&type=script&lang=js"
import style0 from "./sidebar-guest.vue?vue&type=style&index=0&id=210c622a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c622a",
  null
  
)

export default component.exports